import { NgModule } from "@angular/core";
import { CircCommonModule } from "../../../common/common.module";
import { LogClass, Logger } from "../../../logger";
import { StepService } from "../../../services";
import { StepTypeCommonModule } from "../common/step-type-common.module";
import { STEPTYPE_FORCONFIRMATION } from "../constants";
import { CreateTemplateComponent } from "./create-template/create-template.component";
import { CreateComponent } from "./create/create.component";
import { EditTemplateComponent } from "./edit-template/edit-template.component";
import { EditComponent } from "./edit/edit.component";
import { WorkComponent } from "./work/work.component";

@NgModule({
  declarations: [
    EditComponent,
    CreateComponent,
    WorkComponent,
    EditTemplateComponent,
    CreateTemplateComponent
  ],
  imports: [CircCommonModule, StepTypeCommonModule]
})
@LogClass({ source: "StepTypeForConfirmationModule" })
export class StepTypeForConfirmationModule {
  private logger: Logger;

  constructor(stepService: StepService) {
    this.logger.debug("ctor");

    stepService.register({
      id: STEPTYPE_FORCONFIRMATION,
      name: "step_forConfirmation_new_name",
      description: "step_forConfirmation_new_description",
      createComponent: CreateComponent,
      editComponent: EditComponent,
      workComponent: WorkComponent,
      createTemplateComponent: CreateTemplateComponent,
      editTemplateComponent: EditTemplateComponent
    });
  }
}
